<section class="recovery-password-page">
  <form *ngIf="form" class="recovery-password-form" [formGroup]="form" (ngSubmit)="submitRecovery()">
    <p class="h1 fw-light" data-test-id="recovery-password-form-title">
      {{ 'RESET_PASSWORD_TEXT' | translate }}
    </p>
    <div class="password-group" data-test-id="wrap-recovery-form-password">
      <app-eye-password
        [form]="form"
        [controlName]="'password'"
        [dataTestId]="'recovery-form-password'"
        [showValidMark]="true"
        [errorTexting]="texting('recovery-password-form-password-error', 'FIELD_PASSWORD_ERROR')"
        [validTexting]="texting('recovery-password-form-valid-password', 'VALID_LOOKS_GOOD')"
        [instructionTexting]="texting('password-instruction', 'FORM_PASSWORD_INPUT_INSTRUCTION')"
        [placeholder]="'FORM_PASSWORD_INPUT_PLACEHOLDER'"
        [inputLabel]="'FORM_PASSWORD_LABEL'"
        [invalid]="isFieldInvalid('password')"
        [formValid]="isFieldValid('password')"
      >
      </app-eye-password>
    </div>
    <div class="password-group" data-test-id="wrap-recovery-confirm-form-password">
      <app-eye-password
        [form]="form"
        [controlName]="'repeatPassword'"
        [dataTestId]="'recovery-confirm-form-password'"
        [showValidMark]="true"
        [validTexting]="texting('change-password-form-valid-new-password', 'VALID_LOOKS_GOOD')"
        [errorTexting]="texting('recovery-password-form-repeat-password-error', repeatPasswordTextError)"
        [placeholder]="'FORM_REPEAT_PASSWORD_INPUT_PLACEHOLDER'"
        [inputLabel]="'FORM_REPEAT_PASSWORD_LABEL'"
        [invalid]="isRepeatPasswordFieldInvalid()"
        [formValid]="isRepeatPasswordFieldValid()"
      >
      </app-eye-password>
    </div>
    <div class="mb-3">
      <small class="form-text text-muted"> * - {{ 'REQUIRED_FIELD_HINT' | translate }} </small>
    </div>

    <div class="submit-button">
      <button class="btn btn-primary text-white" type="submit" data-test-id="recovery-password-form-recovery-btn">
        {{ 'RESET_PASSWORD_TEXT' | translate }}
      </button>
    </div>
  </form>
</section>
